import "./FeatureGridCard.scss";

type FeatureGridCardProps = {
  svg: React.ReactNode;
  title: string;
  subtitle: string;
  index: number;
  isVisible?: boolean;
};

const FeatureGridCard = (props: FeatureGridCardProps) => {
  const formattedIndex = props.index.toString().padStart(2, '0');

  return (
    <div
      className={`feature-grid-card ${props.isVisible ? "fgc-animate" : ""}`}
      style={{ animationDelay: `${(props.index - 1) * 0.15}s` }}
    >
      <div className="card-top-row">
        <div className="card-icon">{props.svg}</div>
        <div className="card-number">{formattedIndex}</div>
      </div>
      <h5 className="card-title">{props.title}</h5>
      <div className="card-subtitle">{props.subtitle}</div>

    </div>
  );
};

export default FeatureGridCard;
